export default "/images/5e63e07f88b17a0497cdf4793c5cb010.avif";